import {
  SecurityType,
  Series,
  CallFeature,
  CallType,
  BasicDeal,
} from '../../types/deal.types';
import { FirstCallRadioValue } from '../../types/calendar.types';
import { CalendarFilter } from '../../state/calendar-filter/state';
import moment from 'moment';
import { DealMaturities } from './maturity';

export function getCallFeatureForSecurityType(
  series: Series,
  secType: SecurityType
): string {
  const callFeature = series.callFeatures.find(
    (cf) => cf.securityType === secType
  );
  return (callFeature && callFeature.displayText) || '-';
}

export function getFirstCallDateForSecurityType(
  series: Series,
  secType: SecurityType
) {
  const callFeature = series.callFeatures.find(
    (cf) => cf.securityType === secType
  );
  return (callFeature && callFeature.firstCallDate) || undefined;
}

export function getFreeTextForSecurityType(
  series: Series,
  secType: SecurityType
): string {
  const callFeature = series.callFeatures.find(
    (cf) => cf.securityType === secType
  );
  return (callFeature && callFeature.freeText) || null;
}

export function filterFirstCall(
  firstCallFilter: CalendarFilter,
  deal: BasicDeal
) {
  if (firstCallFilter) {
    let callFeatures: CallFeature[];

    if (Array.isArray(deal.maturities) && deal.maturities.length) {
      const callFeaturesBySeriesId = deal.series.reduce((acc, series) => {
        acc[series.id] = DealMaturities.getUniqueSecTypesForMaturitiesBySeries(
          series,
          deal.maturities
        ).reduce((innerAcc, securityType) => {
          innerAcc[securityType] = series.callFeatures.find(
            (cf) => cf.securityType === securityType
          );
          return innerAcc;
        }, {});
        return acc;
      }, {});

      callFeatures = deal.maturities.map(
        (maturity) =>
          maturity.callFeature ||
          callFeaturesBySeriesId[maturity.seriesId][maturity.securityType]
      );
    } else {
      callFeatures = deal.series.reduce((acc, series) => {
        return acc.concat(series.callFeatures);
      }, []);
    }
    return callFeatures.some((cf) =>
      callFeaturePassesFilter(firstCallFilter, cf)
    );
  } else {
    return true;
  }
}

export function callFeaturePassesFilter(
  firstCallFilter: CalendarFilter,
  callFeature?: CallFeature
) {
  switch (firstCallFilter.model.radio) {
    case FirstCallRadioValue.All:
      return true;
    case FirstCallRadioValue.MakeWholeCall:
      return callFeature && callFeature.type === CallType.makeWholeCall;
    case FirstCallRadioValue.NonCall:
      return (
        !callFeature ||
        callFeature.type === CallType.notCallable ||
        callFeature.type === CallType.makeWholeCall
      );
    case FirstCallRadioValue.AnytimeCall:
      return !!callFeature && callFeature.type === CallType.callableAnytime;
    case FirstCallRadioValue.Single:
      return (
        callFeature &&
        callFeature.type === CallType.callable &&
        callFeature.firstCallDate &&
        moment(callFeature.firstCallDate).year() ===
          firstCallFilter.model.minValue
      );
    case FirstCallRadioValue.Range:
      // eslint-disable-next-line no-case-declarations
      const year =
        callFeature &&
        callFeature.type === CallType.callable &&
        callFeature.firstCallDate &&
        moment(callFeature.firstCallDate).year();

      return (
        year &&
        year >= firstCallFilter.model.minValue &&
        year <= firstCallFilter.model.maxValue
      );
    default:
      return true;
  }
}
